import { useEffect } from "react";
import { useNavigate } from "react-router";
import { db } from "@/lib/instantdb";
import { initializeTheme } from "@/lib/stores/ui";
import LoginForm from "@/components/LoginForm";

export default function Login() {
  const { isLoading, user } = db.useAuth();
  const navigate = useNavigate();

  // Initialize theme on first load
  useEffect(() => {
    initializeTheme();
  }, []);

  // Redirect if already logged in
  useEffect(() => {
    if (!isLoading && user) {
      navigate("/");
    }
  }, [isLoading, user, navigate]);

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-background"
        style={{
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-background px-4"
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-primary">Vizi</h1>
        <p className="mt-2 text-muted-foreground">
          AI-powered multi-camera video production
        </p>
      </div>

      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-sm">
        <h2 className="mb-6 text-center text-xl font-semibold text-foreground">
          Sign in to your account
        </h2>
        <LoginForm />
      </div>

      <p className="mt-8 text-center text-sm text-muted-foreground">
        New to Vizi? Just enter your email to get started.
      </p>
    </div>
  );
}
